var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 293 121.7",
    style: {
      enableBackground: "new 0 0 293 121.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.729,
    y1: 62.3263,
    x2: 289.1936,
    y2: 62.3263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#6100A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4557,
    style: {
      stopColor: "#7001A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6409,
    style: {
      stopColor: "#980293"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8947,
    style: {
      stopColor: "#D9057E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#ED0677"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144,38l-13.1,36.4l-14.3-37.7c-2.2-6-7.8-5.6-7.8-5.6H96.7l24.2,59.2c0-0.1,0-0.1-0.1-0.2c0,0,0,0.1,0.1,0.2 c0,0.1,0.1,0.2,0.1,0.2l-0.1-0.3c0.8,2.4,0.6,3.7-0.2,6.1l-0.5,1.5c-2.8,7-6.8,8.9-15.2,8.4v0.1l5.8,14.3 c10.8-0.2,19-3.8,24.4-17.3L164.4,31l0,0l-10.9,0c0,0,0,0,0,0C152.9,31,146.6,31.2,144,38 M175.8,61.8c0-10.5,6.7-17.9,15-17.9 c8.3,0,15,7.3,15,17.9c0,10.3-6.7,17.4-15,17.4C182.6,79.2,175.8,72.1,175.8,61.8 M160.2,61.7c0,18.2,13.7,31.8,30.6,31.8 c16.9,0,30.7-13.6,30.7-31.8c0-18.2-13.8-32-30.7-32C173.9,29.7,160.2,43.5,160.2,61.7 M52.6,38.3c-4.4-5.3-11.1-8.6-19.4-8.6 c-16.7,0-27.4,11.7-27.4,27.2v35.2h5.1c3.5-0.2,10.3-1.9,10.5-12V56.5c0-6.9,4.8-11.6,11.8-11.6c10.3,0,11.4,8.2,11.4,11.6v35.6 h5.1c3.4-0.2,10.2-1.9,10.5-11.9V56.5c0-6.9,5-11.6,11.8-11.6c10.3,0,11.5,8.2,11.5,11.6v35.6h5.1C92,91.9,98.9,90.2,99,79.9V56.9 C99,40.9,89,29.7,72,29.7C64,29.7,57.2,33,52.6,38.3 M242.4,61.8c0-9.7,7-17.5,15.6-17.5c8.6,0,15.6,7.6,15.6,17.5 c0,9.7-7,17.1-15.6,17.1C249.3,79,242.4,71.3,242.4,61.8 M239.2,4.1L239.2,4.1c-10.6,0-12.3,7.2-12.5,10.6v77.3l7.5,0 c6,0.1,7.4-3.7,7.5-5.9v-0.3v-0.3c4.7,5,11.2,7.8,18.6,7.8c16,0,29-13.7,29-31.7c0-18.1-13-31.8-29-31.8c-7,0-13.2,2.6-17.9,7.1 V4.1H239.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.760c6717113922c6e7483c6bc60ca31f.svg";
export { ForwardRef as ReactComponent };